import { render } from "./CinemasHallsItem.vue?vue&type=template&id=77c33aab&scoped=true"
import script from "./CinemasHallsItem.vue?vue&type=script&lang=js"
export * from "./CinemasHallsItem.vue?vue&type=script&lang=js"

import "./CinemasHallsItem.vue?vue&type=style&index=0&id=77c33aab&lang=scss&scoped=true"

import exportComponent from "D:\\main\\spacelab\\cinema-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77c33aab"]])

export default __exports__